import styled from 'styled-components';

export const Root = styled.div`
	padding-top: 50px;
`;

export const Container = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 1430px) {
		max-width: 100%;
		width: 100%;
		box-sizing: border-box;
		margin: 0 auto;
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const ArticleBody = styled.article`
	margin: 30px 0;
`;

export const Title = styled.h1`
	font-size: 36px;
	font-weight: bold;
	color: #000;
`;

export const Info = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 30px;
	max-width: 890px;
`;

export const DateBlock = styled.div`
	font-size: 18px;
`;

export const Img = styled.img`
	max-width: 100%;
	max-height: 480px;
	margin: 30px auto;
`;

export const Wrapper = styled.div`
	position: relative;
	display: flex;

	@media (max-width: 768px) {
		flex-wrap: wrap;
	}
`;

export const Sidebar = styled.div`
	min-width: 280px;

	@media (min-width: 769px) {
		max-width: 360px;
	}

	@media (min-width: 1200px) {
		max-width: 420px;
	}
`;

export const ArticleText = styled.div`
	max-width: 890px;
	margin: 0 40px 0 0;

	@media (min-width: 601px) {
		margin: 0 40px 40px 0;
		min-width: 570px;
	}

	figure {
		margin: 20px 0;

		img {
			max-width: 100%;
		}
	}

	img {
		max-width: 100%;
		height: auto !important;
	}

	figcaption {
		margin-bottom: 20px;
	}

	h3 {
		margin: 60px 0 20px;
		${({ theme }) => theme.typography.headlineXL};
	}
`;

export const LikeButtons = styled.div`
	position: relative;
	display: grid;
	grid-gap: 16px 10px;

	@media (min-width: 1560px) {
		position: ${(props) => (props.isSticky ? 'fixed' : 'absolute')};
		top: 0;
		left: -60px;
		z-index: 99;
		grid-template-rows: 50px;
		grid-template-columns: 1fr;
		transition: top 0.5s ease-in-out;
	}

	@media (max-width: 1559px) {
		grid-template-rows: 1fr;
		grid-template-columns: 50px;
		align-self: flex-start;
		justify-self: flex-end;
		width: 100%;
	}

	@media (max-width: 768px) {
		grid-template-columns: 32px;
		margin-bottom: 20px;
	}
`;
